module.exports = __webpack_public_path__ + "assets/images/scrolly-test/4-desktop.jpg?v=0ac7fe53";